"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2872],{

/***/ 61740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product_sign_up; }
});

// UNUSED EXPORTS: productIdToCluster

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.scss.js

var StyledProductSignUp = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ef6wzw60"
})("display:flex;flex-direction:row;height:50px;.product-logo-image{display:flex;align-items:center;.picture-component{img{width:160px;}}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js

function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var _obj;
var PRODUCT_TYPE_TO_IMAGE = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png"), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png"), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"), _obj);
var _obj1;
var productIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var ProductSignUp = function(_param) {
    var displayImage = _param.displayImage, useCtaText = _param.useCtaText, buttonSize = _param.buttonSize, withButtonArrow = _param.withButtonArrow, ctaText = _param.ctaText, _productType = _param.productType, productType = _productType === void 0 ? products/* WORK_MANAGEMENT_PRODUCT_ID */.py : _productType, _selectedProductIds = _param.selectedProductIds, selectedProductIds = _selectedProductIds === void 0 ? [] : _selectedProductIds, signupClusterId = _param.signupClusterId, useCtaIcon = _param.useCtaIcon, _buttonColor = _param.buttonColor, buttonColor = _buttonColor === void 0 ? color_consts.WHITE_COLOR_NAME : _buttonColor, invert = _param.invert, beforeSubmitCallback = _param.beforeSubmitCallback, excludeFromWMHighIntentExperienceTest = _param.excludeFromWMHighIntentExperienceTest, extraData = _param.extraData, restOfConfig = _object_without_properties(_param, [
        "displayImage",
        "useCtaText",
        "buttonSize",
        "withButtonArrow",
        "ctaText",
        "productType",
        "selectedProductIds",
        "signupClusterId",
        "useCtaIcon",
        "buttonColor",
        "invert",
        "beforeSubmitCallback",
        "excludeFromWMHighIntentExperienceTest",
        "extraData"
    ]);
    var updateClusters = function() {
        var res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach(function(id) {
                var clusterId = productIdToCluster[id];
                if (clusterId) res.push({
                    clusterId: clusterId,
                    clusterType: types.CLUSTER_TYPE
                });
            });
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(res, clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, _object_spread_props(_object_spread({}, restOfConfig), {
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : sizes.SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: function() {
                    updateClusters();
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: _object_spread({
                    selectedProduct: productType
                }, extraData || {}),
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            }))
        ]
    });
};
/* harmony default export */ var product_sign_up = (ProductSignUp);
ProductSignUp.defaultProps = default_props;


/***/ }),

/***/ 12872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ side_by_side_paragraph_and_tags_homepage_first_fold_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./constants/clusters/types.js
var types = __webpack_require__(10945);
// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
// EXTERNAL MODULE: ./services/clusters-service.js + 1 modules
var clusters_service = __webpack_require__(25866);
// EXTERNAL MODULE: ./constants/clusters.js
var constants_clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/colors-utils.js
var colors_utils = __webpack_require__(61012);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clusters-signup/clusters-signup.scss.js




var StyledClustersSignup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1lbjbkk0"
})("&.cluster-selected{animation:breatheOut 0.3s linear;}.signup-button-wrapper{transform:scale(1);button.signup-button{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";&:disabled{background-image:", function(param) {
    var background = param.background;
    return background;
}, ";color:", function(param) {
    var textColor = param.textColor;
    return textColor;
}, ";}}.sign-up-combo-with-text-underline{.sign-up-combo-wrapper{.signup-combo-buttons-button{justify-content:center;.secondary-button-wrapper{.secondary-button{.with-underline{background:unset;.secondary-button-text{padding-left:8px;}}}&:hover{.secondary-button{.with-underline{.secondary-button-text{transition:color 0.15 ease-in-out;color:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}svg path{transition:fill 0.15 ease-in-out;fill:", (0,general/* hexToRgba */.a7)(colors/* default */.Z[color_consts.WHITE_COLOR_NAME], 0.8), ";}}}}}}}.text-wrapper{margin-top:32px;font-size:0.8125rem;text-align:center;padding-left:3px;}}}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/product-sign-up/product-sign-up.js + 2 modules
var product_sign_up = __webpack_require__(61740);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clusters-signup/clusters-signup.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var LIGHT_THEME_BUTTON_OPACITY = "ee";
var ClustersSignup = function(_param) {
    var _clusters = _param.clusters, clusters = _clusters === void 0 ? [] : _clusters, wasClusterSelected = _param.wasClusterSelected, selectedProducts = _param.selectedProducts, buttonColor = _param.buttonColor, removeGradient = _param.removeGradient, buttonSize = _param.buttonSize, restOfConfig = _object_without_properties(_param, [
        "clusters",
        "wasClusterSelected",
        "selectedProducts",
        "buttonColor",
        "removeGradient",
        "buttonSize"
    ]);
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var productType = (0,react.useMemo)(function() {
        return (selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.length) === 1 ? selectedProducts[0] : null;
    }, [
        selectedProducts
    ]);
    var getButtonTextColor = function() {
        if (removeGradient) {
            return buttonColor === color_consts.WHITE_COLOR_NAME ? colors/* default */.Z[color_consts.BRAND_BLACK_BACKGROUND_COLOR] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
        }
        if (buttonColor === color_consts.WHITE_COLOR_NAME && clusters.length === 0) {
            return colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
        }
        return colors/* default */.Z[color_consts.WHITE_COLOR_NAME];
    };
    var getButtonColorBySelectedClusters = function() {
        if (removeGradient) return colors/* default */.Z[buttonColor];
        if ((clusters === null || clusters === void 0 ? void 0 : clusters.length) === 0) {
            return isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[buttonColor]) : colors/* default */.Z[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (clusters.length === 1) {
            var colorName = clusters[0].tagBackgroundColor;
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[colorName]) : colors/* default */.Z[colorName];
            return "linear-gradient(90deg, ".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 0%, ").concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " 100%)");
        }
        var colorsString = "";
        var chunkSize = 100 / (clusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        clusters === null || clusters === void 0 ? void 0 : clusters.forEach(function(param, index) {
            var tagBackgroundColor = param.tagBackgroundColor;
            // add separator in every chunk instead of last chunk
            var separator = index === clusters.length - 1 ? "" : ", ";
            var color = isHover ? (0,colors_utils/* getHoverColor */.n)(colors/* default */.Z[tagBackgroundColor]) : colors/* default */.Z[tagBackgroundColor];
            colorsString += "".concat(color).concat(LIGHT_THEME_BUTTON_OPACITY, " ").concat(chunkSize * index, "%").concat(separator);
        });
        return "linear-gradient(90deg, ".concat(colorsString, ")");
    };
    var saveClustersOnSignup = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIGNUP_WITH_TAGS, {
            info1: clusters.map(function(tag) {
                return tag.tagText;
            })
        });
        var clustersToUpdate = clusters === null || clusters === void 0 ? void 0 : clusters.map(function(tag) {
            var clusterId = tag.overridePageCluster;
            var useCaseId = tag.overridePageSubCluster;
            var res = [];
            clusterId && res.push({
                clusterId: clusterId,
                clusterType: types.CLUSTER_TYPE
            });
            if (useCaseId) {
                var extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: types.USE_CASE_TYPE,
                    extraData: extraData
                });
            }
            return res;
        });
        var flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            (0,hotjar_service/* fireHotjarEvents */.no)(flattenedArray.map(function(cluster) {
                return "tag_selected_".concat(cluster.clusterType, "_").concat(cluster.clusterId);
            }));
            (0,clusters_service/* updateUserClustersListWithMultipleClusters */.aC)(flattenedArray, constants_clusters.HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClustersSignup, {
        background: getButtonColorBySelectedClusters(),
        textColor: getButtonTextColor(),
        className: classnames_default()("clusters-signup", {
            "cluster-selected": wasClusterSelected
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseEnter: function() {
                return setIsHover(true);
            },
            onMouseLeave: function() {
                return setIsHover(false);
            },
            className: "cta-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_sign_up/* default */.Z, _object_spread_props(_object_spread({}, restOfConfig), {
                buttonSize: buttonSize || "",
                buttonColor: color_consts.WORK_OS_IRIS_COLOR_NAME,
                productType: productType,
                skipUpdateCluster: false,
                beforeSubmitCallback: saveClustersOnSignup
            }))
        })
    });
};
/* harmony default export */ var clusters_signup = (ClustersSignup);

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-component.scss.js


var getValidatedFactor = function(factor) {
    return parseFloat(factor) || 1;
};
var StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1uc30j60"
})("	display:flex;gap:", function(param) {
    var gap = param.gap;
    return gap;
}, ";min-height:", function(param) {
    var minHeight = param.minHeight;
    return minHeight;
}, ";&:not(.vertical-view){margin-left:calc(max((100vw - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px) / 2 + 32px,32px));}&.vertical-view{flex-direction:column;align-items:center;margin:0 32px;}.full-paragraph{margin-top:", function(param) {
    var fullParagraphTopMargin = param.fullParagraphTopMargin;
    return fullParagraphTopMargin;
}, ";width:fit-content;justify-content:center;}.tags-and-assets-component{flex:1;.tags-cta-container{display:flex;justify-content:center;.cta-wrapper{width:fit-content;.product-sign-up{height:40px;.signup-button{height:40px;}}}}}", function(param) {
    var resizingFactor = param.resizingFactor, _tagsTitleFontSize = param.tagsTitleFontSize, tagsTitleFontSize = _tagsTitleFontSize === void 0 ? "16" : _tagsTitleFontSize;
    return "\n  .clickable-tags-grid {\n    gap: calc(min(20 * (100vw / 1920) * ".concat(getValidatedFactor(resizingFactor), ", 20px));\n    padding: calc(min(24 * (100vw / 1920) * ").concat(getValidatedFactor(resizingFactor), ", 24px));\n    border-radius: calc(min(18 * (100vw / 1920) * ").concat(getValidatedFactor(resizingFactor), ", 18px));\n\n    .animated-text-component {\n      font-size: calc(max(min(").concat(tagsTitleFontSize, " * (100vw / 1920) * ").concat(getValidatedFactor(resizingFactor), ", ").concat(tagsTitleFontSize, "px), 0.8125rem));\n    }\n\n    .tags-container {\n      grid-gap: calc(min(12 * (100vw / 1920) * ").concat(getValidatedFactor(resizingFactor), ", 12px));\n\n      .tag-component {\n        font-size: calc(max(min(14 * (100vw / 1920), 0.875rem) * ").concat(getValidatedFactor(resizingFactor), ", 0.75rem));\n        width: calc(max(min(100 * (100vw / 1920), 100px) * ").concat(getValidatedFactor(resizingFactor), ", 80px));\n        height: calc(max(min(96 * (100vw / 1920), 96px) * ").concat(getValidatedFactor(resizingFactor), ", 76px));\n\n        .checkbox {\n          top: calc(max(min(10 * (100vw / 1920), 10px) * ").concat(getValidatedFactor(resizingFactor), ", 7.5px));\n          left: calc(max(min(10 * (100vw / 1920), 10px) * ").concat(getValidatedFactor(resizingFactor), ", 7.5px));\n          width: calc(max(min(16 * (100vw / 1920), 16px) * ").concat(getValidatedFactor(resizingFactor), ", 12px));\n          height: calc(max(min(16 * (100vw / 1920), 16px) * ").concat(getValidatedFactor(resizingFactor), ", 12px));\n          border-radius: calc(max(min(4 * (100vw / 1920) * ").concat(getValidatedFactor(resizingFactor), ", 4px), 2.5px));\n\n          .checkmark svg {\n            width: calc(max(min(9 * (100vw / 1920), 9px) * ").concat(getValidatedFactor(resizingFactor), ", 7px));\n            height: calc(max(min(8 * (100vw / 1920), 8px) * ").concat(getValidatedFactor(resizingFactor), ", 6px));\n          }\n        }\n\n        .icon {\n          svg {\n            height: calc(max(min(20 * (100vw / 1920), 20px) * ").concat(getValidatedFactor(resizingFactor), ", 16px));\n            width: calc(max(min(20 * (100vw / 1920), 20px) * ").concat(getValidatedFactor(resizingFactor), ", 16px));\n          }\n        }\n      }\n    }\n  }\n	");
});

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid.scss.js



var StyledClickableTagsGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1e3293k0"
})("	display:flex;flex-direction:column;width:fit-content;padding:24px 16px 16px;gap:20px;background:linear-gradient(180deg,rgba(255,255,255,0.8) 40%,rgba(240,243,255,0.3) 80%);box-shadow:3.977px 3.977px 34.8px 0 rgba(0,0,0,0.15);border-radius:18px;border:1px solid ", colors/* default */.Z[color_consts.GAINSBORO_COLOR_NAME], ";backdrop-filter:blur(24px);.animated-text-component{display:flex;justify-content:", function(param) {
    var tagsTitleAlignment = param.tagsTitleAlignment;
    return tagsTitleAlignment;
}, ";}.tags-container{width:fit-content;display:grid;grid-template-rows:1fr 1fr 1fr;grid-template-columns:1fr 1fr 1fr;grid-gap:12px;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/checkbox.scss.js



var StyledCheckbox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1wtfxrn0"
})("cursor:pointer;position:relative;border-radius:4px;background-color:", colors/* default.White */.Z.White, ";border:1.25px solid ", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR], ";width:16px;height:16px;display:flex;align-items:center;justify-content:center;.checkmark{opacity:0;display:flex;transition:opacity 0.2s ease-in-out;}", function(param) {
    var hovered = param.hovered, color = param.color;
    return hovered && "border-color: ".concat(color);
}, ";&.checked{border-color:", function(param) {
    var color = param.color;
    return color;
}, ";.checkmark{opacity:1;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/check-icon.js

var CheckIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "9",
        height: "8",
        viewBox: "0 0 9 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1 3.5L3.5 6.5L7.5 1",
            stroke: color || "#6161FF",
            "stroke-width": "1.25",
            strokeLinecap: "round"
        })
    });
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/checkbox/checkbox.js





var Checkbox = function(param) {
    var checked = param.checked, color = param.color, hovered = param.hovered;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
        hovered: hovered,
        color: color,
        className: classnames_default()("checkbox", {
            checked: checked
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "checkmark",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {
                color: color
            })
        })
    });
};
/* harmony default export */ var checkbox_checkbox = (Checkbox);

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/tag/tag-component.scss.js



var TAG_WIDTH = 100;
var TAG_HEIGHT = 96;
var StyledTagComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1n0wom20"
})("display:flex;position:relative;align-items:center;gap:8px;flex-direction:column;flex-wrap:wrap;justify-content:center;border-radius:8px;background-color:", colors/* default.White */.Z.White, ";border:0.6px solid ", colors/* default */.Z[color_consts.UI_BORDER_LIGHT_COLOR], ";width:", TAG_WIDTH, "px;height:", TAG_HEIGHT, "px;cursor:pointer;font-size:0.875rem;&:hover{box-shadow:0 0 20px 0 rgba(0,0,0,0.08);}&.tag-animation{animation:breatheOut 0.3s linear;}.checkbox{position:absolute;top:10px;left:10px;}@keyframes breatheOut{0%{transform:scale(1);}15%{transform:scale(1.01);}20%{transform:scale(1.02);}25%{transform:scale(1.03);}32%{transform:scale(1.04);}50%{transform:scale(1.05);}68%{transform:scale(1.04);}75%{transform:scale(1.03);}80%{transform:scale(1.02);}85%{transform:scale(1.01);}100%{transform:scale(1);}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/tag/tag-component.js








var TagComponent = function(param) {
    var onClick = param.onClick, Icon = param.Icon, text = param.text, tagColor = param.tagColor, selected = param.selected, handleTagHoverStart = param.handleTagHoverStart, handleTagHoverEnd = param.handleTagHoverEnd;
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    var ref1 = (0,react.useState)(false), tagAnimation = ref1[0], setTagAnimation = ref1[1];
    var onTagClick = function() {
        setTagAnimation(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_CLICKED, {
            kind: text
        });
        onClick && onClick();
    };
    var onMouseEnter = function() {
        handleTagHoverStart();
        setIsHover(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.GRID_TAG_HOVERED, {
            kind: text
        });
    };
    var onMouseLeave = function() {
        handleTagHoverEnd();
        setIsHover(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagComponent, {
        color: colors/* default */.Z[tagColor],
        className: classnames_default()("tag-component", {
            selected: selected,
            "tag-animation": tagAnimation
        }),
        onMouseLeave: onMouseLeave,
        onMouseEnter: onMouseEnter,
        onClick: onTagClick,
        onAnimationEnd: function() {
            return setTagAnimation(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_checkbox, {
                color: colors/* default */.Z[tagColor],
                checked: selected,
                hovered: isHover
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "icon",
                children: Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: (selected || isHover) && colors/* default */.Z[tagColor]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text",
                children: text
            })
        ]
    });
};
/* harmony default export */ var tag_component = (TagComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/animated-text/animated-text-component.scss.js



var ANIMATION_DELAY = 0.05;
var ANIMATION_DURATION = 0.5;
var getAnimationStyle = function(wordIndex) {
    return "\n  .animated-word:nth-child(".concat(wordIndex + 1, ") {\n    animation-delay: ").concat(wordIndex * ANIMATION_DELAY, "s;\n  }\n");
};
var getWordAnimationsStyle = function(words) {
    return words.map(function(word, index) {
        return getAnimationStyle(index);
    }).join("\n");
};
var StyledAnimatedTextComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3zr0hf0"
})("display:flex;font-size:1rem;line-height:24px;position:relative;.animated-word{position:relative;display:inline-block;font-weight:400;animation:textAnimation ", ANIMATION_DURATION, "s ease-in-out forwards;}", function(param) {
    var words = param.words;
    return getWordAnimationsStyle(words);
}, ";@keyframes textAnimation{0%,100%{color:black;}50%{color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR], ";}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/animated-text/animated-text-component.js


var AnimatedTextComponent = function(param) {
    var _text = param.text, text = _text === void 0 ? "" : _text;
    var words = text === null || text === void 0 ? void 0 : text.split("");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedTextComponent, {
        words: words,
        className: "animated-text-component",
        children: words.map(function(word, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "animated-word",
                children: word === " " ? "\xa0" : word
            }, index);
        })
    });
};
/* harmony default export */ var animated_text_component = (AnimatedTextComponent);

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/default-props.js
/* harmony default export */ var default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid.js

function clickable_tags_grid_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function clickable_tags_grid_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            clickable_tags_grid_define_property(target, key, source[key]);
        });
    }
    return target;
}
function clickable_tags_grid_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function clickable_tags_grid_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        clickable_tags_grid_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var ClickableTagsGrid = function(param) {
    var tags = param.tags, tagsTitle = param.tagsTitle, onTagSelectionChange = param.onTagSelectionChange, renderCta = param.renderCta, tagsTitleAlignment = param.tagsTitleAlignment, handleTagHover = param.handleTagHover;
    var ref = (0,react.useState)([]), selectedTags = ref[0], setSelectedTags = ref[1];
    var handleCardClick = function(tag) {
        var updatedSelectedTags = selectedTags.includes(tag) ? selectedTags.filter(function(selectedTag) {
            return selectedTag !== tag;
        }) : (0,_to_consumable_array/* default */.Z)(selectedTags).concat([
            tag
        ]);
        setSelectedTags(updatedSelectedTags);
        onTagSelectionChange && onTagSelectionChange(updatedSelectedTags);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledClickableTagsGrid, {
        tagsTitleAlignment: tagsTitleAlignment,
        className: "clickable-tags-grid",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(animated_text_component, {
                text: tagsTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tags-container",
                children: tags === null || tags === void 0 ? void 0 : tags.map(function(tag, index) {
                    return /*#__PURE__*/ (0,react.createElement)(tag_component, clickable_tags_grid_object_spread_props(clickable_tags_grid_object_spread({}, tag), {
                        key: index,
                        selected: selectedTags.includes(tag),
                        onClick: function() {
                            return handleCardClick(tag);
                        },
                        handleTagHoverStart: function() {
                            return handleTagHover(tag);
                        },
                        handleTagHoverEnd: function() {
                            return handleTagHover(null);
                        }
                    }));
                })
            }),
            renderCta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tags-cta-container",
                children: renderCta()
            })
        ]
    });
};
/* harmony default export */ var clickable_tags_grid = (ClickableTagsGrid);
ClickableTagsGrid.defaultProps = default_props;

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/tags-and-assets/tags-and-assets-component.scss.js


var IMAGE_DEFAULT_MAX_WIDTH = "900px";
var DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE = "10vw";
var getBreathAnimation = function(isCentralized, flipUseCasesAndAssets) {
    var transformStyle = isCentralized ? "translateX(".concat(flipUseCasesAndAssets ? "50%" : "-50%", ")") : "";
    return "\n    @keyframes breathe {\n    0% {\n      transform: ".concat(transformStyle, " scale(1);\n    }\n    50% {\n      transform: ").concat(transformStyle, " scale(1.05);\n    }\n    100% {\n      transform: ").concat(transformStyle, " scale(1);\n    }\n  }\n  ");
};
var StyledTagsAndAssetsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "es1qpe70"
})("	position:relative;width:fit-content;&.centered{.use-cases-container{", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "right: 50%;" : "left: 50%;";
}, "			", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "transform: translateX(50%);" : "transform: translateX(-50%);";
}, "}}&.movement-animation{.use-cases-container{animation:moveToPositionFromCenter 1s forwards ease;}}&:not(.centered){.use-cases-container{", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "right: 0;" : "left: 0;";
}, "}.assets-container{transition:margin 1s ease;transition-delay:", function(param) {
    var startAtCenterAnimationDelay = param.startAtCenterAnimationDelay;
    return parseFloat(startAtCenterAnimationDelay) || 0;
}, "s;", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets, assetsAndTagsExtraSpace = param.assetsAndTagsExtraSpace;
    return flipUseCasesAndAssets ? "margin-right: ".concat(assetsAndTagsExtraSpace || DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE, ";") : "margin-left: ".concat(assetsAndTagsExtraSpace || DEFAULT_ASSETS_AND_TAGS_EXTRA_SPACE, ";");
}, "}}.use-cases-container{z-index:", z_index/* LAYER_TWO */.wc, ";position:absolute;top:", function(param) {
    var useCasesTopMargin = param.useCasesTopMargin;
    return useCasesTopMargin || "calc(132 * (100vw / 1920))";
}, ";&.breathe{animation:breathe 0.3s linear;}}img{width:100%;object-fit:contain;max-width:", function(param) {
    var imageMaxWidth = param.imageMaxWidth;
    return imageMaxWidth || IMAGE_DEFAULT_MAX_WIDTH;
}, ";}.default-asset{opacity:0;transition:opacity 0.3s ease-in-out;.asset-inner img{", function(param) {
    var blurDefaultImage = param.blurDefaultImage;
    return blurDefaultImage ? "filter: blur(5px);" : "";
}, "			", function(param) {
    var blurDefaultImage = param.blurDefaultImage;
    return blurDefaultImage ? "opacity: 0.5;" : "";
}, "}&.active{display:block;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";opacity:1;}}.assets-container{z-index:", z_index/* LAYER_ONE */.KW, ";position:relative;width:fit-content;min-width:", function(param) {
    var imageMaxWidth = param.imageMaxWidth;
    return imageMaxWidth;
}, ";.picture-wrapper{width:fit-content;position:absolute;opacity:0;top:0;left:0;transition:opacity 0.3s ease-in-out;&.selected{opacity:1;}}}@keyframes moveToPositionFromCenter{0%{", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "right: 50%;" : "left: 50%;";
}, "			", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "transform: translateX(50%);" : "transform: translateX(-50%);";
}, "}100%{", function(param) {
    var flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return flipUseCasesAndAssets ? "right: 0;" : "left: 0;";
}, "			transform:translateX(0);}}", function(param) {
    var isCentralized = param.isCentralized, flipUseCasesAndAssets = param.flipUseCasesAndAssets;
    return getBreathAnimation(isCentralized, flipUseCasesAndAssets);
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/tags-and-assets/tags-and-assets-component.js
function tags_and_assets_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_and_assets_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_and_assets_component_define_property(target, key, source[key]);
        });
    }
    return target;
}









var TagsAndAssetsComponent = function(param) {
    var tagsTitle = param.tagsTitle, tags = param.tags, defaultImage = param.defaultImage, onClustersChange = param.onClustersChange, enabledDefaultImageAnimation = param.enabledDefaultImageAnimation, flipUseCasesAndAssets = param.flipUseCasesAndAssets, renderCta = param.renderCta, useCasesTopMargin = param.useCasesTopMargin, imageMaxWidth = param.imageMaxWidth, assetsAndTagsExtraSpace = param.assetsAndTagsExtraSpace, startAtCenter = param.startAtCenter, blurDefaultImage = param.blurDefaultImage, tagsTitleAlignment = param.tagsTitleAlignment, enableTagsHoverChangingAssets = param.enableTagsHoverChangingAssets;
    var ref = (0,react.useState)(false), wasInteracted = ref[0], setWasInteracted = ref[1];
    var ref1 = (0,react.useState)(null), latestSelectedTab = ref1[0], setLatestSelectedTab = ref1[1];
    var ref2 = (0,react.useState)(false), didDefaultClicked = ref2[0], setDidDefaultClicked = ref2[1];
    var ref3 = (0,react.useState)(null), hoverTag = ref3[0], setHoverTag = ref3[1];
    var ref4 = (0,react.useState)(false), shouldSetMoveToPositionAnimation = ref4[0], setShouldSetMoveToPositionAnimation = ref4[1];
    var isCentralized = startAtCenter && !wasInteracted;
    var tagAssets = (0,react.useMemo)(function() {
        return tags === null || tags === void 0 ? void 0 : tags.map(function(param) {
            var tagImage = param.tagImage;
            return tagImage;
        });
    }, [
        tags
    ]);
    var onTagSelectionChange = (0,react.useCallback)(function(selectedTags) {
        !wasInteracted && setWasInteracted(true);
        setLatestSelectedTab(selectedTags[selectedTags.length - 1] || null);
        onClustersChange(selectedTags);
    }, []);
    (0,react.useEffect)(function() {
        if (startAtCenter && wasInteracted) {
            setShouldSetMoveToPositionAnimation(true);
        }
    }, [
        startAtCenter,
        wasInteracted
    ]);
    var onAssetClick = function() {
        if (latestSelectedTab) return;
        setDidDefaultClicked(true);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.TAGS_DEFAULT_ASSET_CLICKED);
    };
    var handleAnimationEnd = function(event) {
        if (event.animationName === "moveToPositionFromCenter") {
            setShouldSetMoveToPositionAnimation(false);
        }
        if (event.animationName === "breathe") {
            setDidDefaultClicked(false);
        }
    };
    var handleTagHover = function(tag) {
        setHoverTag(tag);
    };
    var selectedTagToShow = enableTagsHoverChangingAssets ? hoverTag || latestSelectedTab : latestSelectedTab;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTagsAndAssetsComponent, {
        onAnimationEnd: handleAnimationEnd,
        className: classnames_default()("tags-and-assets-component", {
            centered: isCentralized,
            "movement-animation": shouldSetMoveToPositionAnimation
        }),
        flipUseCasesAndAssets: flipUseCasesAndAssets,
        isCentralized: isCentralized,
        useCasesTopMargin: useCasesTopMargin,
        imageMaxWidth: imageMaxWidth,
        blurDefaultImage: blurDefaultImage,
        assetsAndTagsExtraSpace: assetsAndTagsExtraSpace,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("use-cases-container", {
                    breathe: enabledDefaultImageAnimation && didDefaultClicked
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clickable_tags_grid, {
                    tagsTitleAlignment: tagsTitleAlignment,
                    onTagSelectionChange: onTagSelectionChange,
                    tags: tags,
                    renderCta: renderCta,
                    tagsTitle: tagsTitle,
                    handleTagHover: handleTagHover
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "assets-container",
                onClick: onAssetClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("default-asset", {
                            active: !latestSelectedTab
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, tags_and_assets_component_object_spread({
                            hideControls: true
                        }, defaultImage))
                    }),
                    tagAssets === null || tagAssets === void 0 ? void 0 : tagAssets.map(function(tagAsset, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("picture-wrapper", {
                                selected: selectedTagToShow === tags[index]
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                src: (tagAsset === null || tagAsset === void 0 ? void 0 : tagAsset.src) || (defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src)
                            }, index)
                        });
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var tags_and_assets_component = (TagsAndAssetsComponent);

// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/consts.js + 11 modules
var consts = __webpack_require__(7861);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-component.js
function side_by_side_paragraph_and_tags_homepage_first_fold_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_tags_homepage_first_fold_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_paragraph_and_tags_homepage_first_fold_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var SIGNUP_BUTTON_ANIMATION_START_TIME = 100;
var SideBySideParagraphAndTagsHomepageFirstFoldComponent = function(param) {
    var fullParagraph = param.fullParagraph, gap = param.gap, tagsTitle = param.tagsTitle, tags = param.tags, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, defaultImage = param.defaultImage, minHeight = param.minHeight, fullParagraphTopMargin = param.fullParagraphTopMargin, enabledDefaultImageAnimation = param.enabledDefaultImageAnimation, useTagsClusterCTA = param.useTagsClusterCTA, flipUseCasesAndAssets = param.flipUseCasesAndAssets, verticalView = param.verticalView, imageMaxWidth = param.imageMaxWidth, resizingFactor = param.resizingFactor, useCasesTopMargin = param.useCasesTopMargin, assetsAndTagsExtraSpace = param.assetsAndTagsExtraSpace, startAtCenter = param.startAtCenter, tagsTitleFontSize = param.tagsTitleFontSize, blurDefaultImage = param.blurDefaultImage, tagsTitleAlignment = param.tagsTitleAlignment, setStartShowingStickyHeader = param.setStartShowingStickyHeader, isInView = param.isInView, enableTagsHoverChangingAssets = param.enableTagsHoverChangingAssets;
    var ref = (0,react.useState)([]), selectedClusters = ref[0], setSelectedClusters = ref[1];
    var ref1 = (0,react.useState)(false), wasClusterSelected = ref1[0], setWasClusterSelected = ref1[1];
    (0,react.useEffect)(function() {
        setStartShowingStickyHeader(!isInView);
    }, [
        isInView,
        setStartShowingStickyHeader
    ]);
    var getGetTagIcon = (0,react.useCallback)(function(tag) {
        return consts/* NAME_TO_ICON */.qs[tag === null || tag === void 0 ? void 0 : tag.tagIconName] || consts/* CLUSTER_TO_TAG_ICON_MAP */.Ho[tag === null || tag === void 0 ? void 0 : tag.overridePageCluster] || consts/* CLUSTER_TO_TAG_ICON_MAP */.Ho[tag === null || tag === void 0 ? void 0 : tag.overridePageSubCluster];
    }, []);
    var assetTags = (0,react.useMemo)(function() {
        return tags === null || tags === void 0 ? void 0 : tags.map(function(_param) {
            var tagText = _param.tagText, tagColor = _param.tagColor, tag = side_by_side_paragraph_and_tags_homepage_first_fold_component_object_without_properties(_param, [
                "tagText",
                "tagColor"
            ]);
            return side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({}, tag), {
                text: tagText,
                tagColor: tagColor,
                Icon: getGetTagIcon(tag)
            });
        });
    }, [
        tags,
        getGetTagIcon
    ]);
    var selectedProducts = (0,react.useMemo)(function() {
        return selectedClusters.map(function(param) {
            var overridePageCluster = param.overridePageCluster;
            return (0,consts/* getClusterProduct */.Uz)(overridePageCluster);
        });
    }, [
        selectedClusters
    ]);
    var onClustersChange = function(selectedTags) {
        setSelectedClusters(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.map(function(param) {
            var tagColor = param.tagColor, overridePageCluster = param.overridePageCluster, overridePageSubCluster = param.overridePageSubCluster;
            return {
                tagBackgroundColor: tagColor,
                overridePageSubCluster: overridePageSubCluster,
                overridePageCluster: overridePageCluster
            };
        }));
        selectedTags && setTimeout(function() {
            return setWasClusterSelected(true);
        }, SIGNUP_BUTTON_ANIMATION_START_TIME);
    };
    var renderClusterCTA = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(clusters_signup, side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread_props(side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({}, props), {
            wasClusterSelected: wasClusterSelected,
            clusters: selectedClusters,
            selectedProducts: selectedProducts
        }));
    };
    var renderTagsClusterCTA = function() {
        var extraData = {
            component: "TagsAndAssetsComponent"
        };
        return renderClusterCTA({
            extraData: extraData,
            buttonSize: sizes.XS
        });
    };
    var renderFullParagraphClusterCTA = function() {
        var _fullParagraph_buttonConfig;
        return (fullParagraph === null || fullParagraph === void 0 ? void 0 : (_fullParagraph_buttonConfig = fullParagraph.buttonConfig) === null || _fullParagraph_buttonConfig === void 0 ? void 0 : _fullParagraph_buttonConfig.buttonType) === button_consts/* SIGNUP_BUTTON_TYPE */.ge ? renderClusterCTA(fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) : null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideParagraphAndTagsHomepageFirstFoldComponent, {
        gap: gap,
        resizingFactor: resizingFactor,
        minHeight: minHeight,
        fullParagraphTopMargin: fullParagraphTopMargin,
        tagsTitleFontSize: tagsTitleFontSize,
        className: classnames_default()("side-by-side-paragraph-and-tags-homepage-first-fold-component", {
            "vertical-view": verticalView
        }),
        onAnimationEnd: function() {
            return setWasClusterSelected(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_paragraph_and_tags_homepage_first_fold_component_object_spread({
                renderButton: renderFullParagraphClusterCTA
            }, fullParagraph, fullParagraphAdvancedConfig)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(tags_and_assets_component, {
                assetsAndTagsExtraSpace: assetsAndTagsExtraSpace,
                flipUseCasesAndAssets: flipUseCasesAndAssets,
                onClustersChange: onClustersChange,
                tagsTitle: tagsTitle,
                useCasesTopMargin: useCasesTopMargin,
                tags: assetTags,
                imageMaxWidth: imageMaxWidth,
                renderCta: useTagsClusterCTA && renderTagsClusterCTA,
                defaultImage: defaultImage,
                enabledDefaultImageAnimation: enabledDefaultImageAnimation,
                startAtCenter: startAtCenter,
                blurDefaultImage: blurDefaultImage,
                tagsTitleAlignment: tagsTitleAlignment,
                enableTagsHoverChangingAssets: enableTagsHoverChangingAssets
            })
        ]
    });
};
/* harmony default export */ var side_by_side_paragraph_and_tags_homepage_first_fold_component = (SideBySideParagraphAndTagsHomepageFirstFoldComponent);


/***/ })

}]);